import * as React from 'react';

import { Field } from '../Field';
import { TextAndIcon } from './parts/TextAndIcon';
import * as styles from './TextAndIconField.css';

export interface IItem {
  icon: React.ReactNode;
  text: React.ReactNode;
}

interface ITextAndIconFieldProps {
  items: IItem[];
  published?: boolean;
}

export const TextAndIconField: React.FC<ITextAndIconFieldProps> = ({ items, published }) => {
  return (
    <Field noPadding published={published} className={styles['container']}>
      {items.map((item, index) => {
        const { icon, text } = item;

        return (
          <TextAndIcon icon={icon} key={index}>
            {text}
          </TextAndIcon>
        );
      })}
    </Field>
  );
};
